import React from 'react';

import { modifyColor, silenceError } from '@nfctron/nexus-core';

import { Badge as MantineBadge } from '@mantine/core';
import Color from 'color';

import type { Component, ComponentDisplayName } from '@root/lib/types/components';

import type { CategoryBadgeProps } from './CategoryBadge.types';

/**
 * CategoryBadge component
 * @author filipditrich <ditrich@nfctron.com>
 * @constructor
 */
export const CategoryBadge: Component<CategoryBadgeProps> = ({ category, ...props }) => {
	const textColor = silenceError(() => modifyColor(category.color, (c) => (c.isLight() ? Color('#000') : Color('#fff'))), '#FFFFFF');
	return (
		<MantineBadge
			variant="dot"
			color={textColor}
			styles={{
				root: {
					backgroundColor: category.color,
					color: textColor,
					borderColor: category.color,
					'&::before': {
						backgroundColor: textColor,
					},
				},
			}}
			{...props}
		>
			{category.name}
		</MantineBadge>
	);
};

/**
 * CategoryBadge component display name
 * @type {ComponentDisplayName}
 */
CategoryBadge.displayName = 'component/CategoryBadge';
